import {
    LegsShapeId,
    LowTableId,
    TrayShapeId,
    TrayVolumeShapeId,
} from '@core/constants/Shape';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import { MaterialId } from '@core/constants/Material';
import {
    IFormInputType,
    IDimensionUnit,
    IFormFieldShapeDimension,
    IFormFieldMaterial,
    IFormFieldShapeQuantities,
    IFormFieldShape,
} from '../../../interfaces/Form';
import allMaterials, {
    allCeramics,
    allConcretes,
    allMarbleAndStones,
    allMetals,
    allNaturalFiber,
    allSolidWoods,
    getMaterialsWithExceptions,
} from './materialGroups';
import allLegs, { allBorders, getLegsWithExceptions } from './shapesGroups';

export const lowNestingTableTrayShapeDimension: IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            TrayShapeId.TraysSquare,
            TrayShapeId.TrayRectangle,
            TrayShapeId.TrayRound,
            TrayShapeId.TrayOval,
            TrayShapeId.TrayHexagonal,
            TrayShapeId.TrayTriangle,
        ],
        required: true,
    },
    dimension: {
        options: {
            [TrayShapeId.TraysSquare]: {
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.WidthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayRectangle]: {
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.LengthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.WidthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayRound]: {
                [FieldDimensionId.Diameter]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.DiameterTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayOval]: {
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.LengthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.WidthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayHexagonal]: {
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.WidthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayTriangle]: {
                [FieldDimensionId.Width1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.Width1Table2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.Width2Table2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.Width3Table2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
        },
    },
};

export const lowNestingTableNoLegsTrayShapeDimension: IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            TrayVolumeShapeId.TraysVolumeSquare,
            TrayVolumeShapeId.TrayVolumeRectangle,
            TrayVolumeShapeId.TrayVolumeRound,
            TrayVolumeShapeId.TrayVolumeOval,
            TrayVolumeShapeId.TrayVolumeHexagonal,
            TrayVolumeShapeId.TrayVolumeTriangle,
        ],
        required: true,
    },
    dimension: {
        options: {
            [TrayVolumeShapeId.TraysVolumeSquare]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.HeightTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.WidthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayVolumeShapeId.TrayVolumeRectangle]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.HeightTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.LengthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.WidthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayVolumeShapeId.TrayVolumeRound]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Diameter]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.HeightTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.DiameterTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayVolumeShapeId.TrayVolumeOval]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.HeightTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.LengthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.WidthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayVolumeShapeId.TrayVolumeHexagonal]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.HeightTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.WidthTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayVolumeShapeId.TrayVolumeTriangle]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Width1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
                [FieldDimensionId.HeightTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Width1Table2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.Width2Table2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.Width3Table2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 400, max: 3500 },
                    required     : true,
                    defaultValue : 800,
                },
                [FieldDimensionId.ThicknessTable2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
        },
    },
};

export const lowTableTrayShapeDimension: IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            TrayShapeId.TraysSquare,
            TrayShapeId.TrayRectangle,
            TrayShapeId.TrayRound,
            TrayShapeId.TrayOval,
            TrayShapeId.TrayHexagonal,
            TrayShapeId.TrayTriangle,
        ],
        required: true,
    },
    dimension: {
        options: {
            [TrayShapeId.TraysSquare]: {
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayRectangle]: {
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayRound]: {
                [FieldDimensionId.Diameter]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayOval]: {
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayHexagonal]: {
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayShapeId.TrayTriangle]: {
                [FieldDimensionId.Width1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
        },
    },
};

export const lowTableNoLegsTrayShapeDimension: IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            TrayVolumeShapeId.TraysVolumeSquare,
            TrayVolumeShapeId.TrayVolumeRectangle,
            TrayVolumeShapeId.TrayVolumeRound,
            TrayVolumeShapeId.TrayVolumeOval,
            TrayVolumeShapeId.TrayVolumeHexagonal,
            TrayVolumeShapeId.TrayVolumeTriangle,
        ],
        required: true,
    },
    dimension: {
        options: {
            [TrayVolumeShapeId.TraysVolumeSquare]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayVolumeShapeId.TrayVolumeRectangle]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayVolumeShapeId.TrayVolumeRound]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Diameter]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayVolumeShapeId.TrayVolumeOval]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Length]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayVolumeShapeId.TrayVolumeHexagonal]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
            [TrayVolumeShapeId.TrayVolumeTriangle]: {
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 200, max: 800 },
                    required     : true,
                    defaultValue : 400,
                },
                [FieldDimensionId.Width1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Width3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 100,
                    range        : { min: 500, max: 4000 },
                    required     : true,
                    defaultValue : 900,
                },
                [FieldDimensionId.Thickness]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 10, max: 100 },
                    required     : true,
                    defaultValue : 20,
                },
            },
        },
    },
};

export const fieldsLowTableMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions([...allMaterials, ...allNaturalFiber],
            [
                MaterialId.BlackLocust,
                MaterialId.Iroko,
                MaterialId.Douglas,
                MaterialId.DouglasEngineered,
                MaterialId.DouglasRecycled,
                MaterialId.DouglasVeneer,
                MaterialId.Padouk,
                MaterialId.PadoukEngineered,
                MaterialId.PadoukRecycled,
                MaterialId.PadoukVeneer,
                MaterialId.Ipe,
                MaterialId.IpeRecycled,
                MaterialId.IpeEngineered,
                MaterialId.IpeVeneer,
                MaterialId.Aluminum,
                MaterialId.Zinc,
                MaterialId.Brass,
                MaterialId.PlexiglassFluorescent,
                MaterialId.PlexiglassFrosted,
                MaterialId.PlexiglassMirror,
                MaterialId.PlexiglassTransparent,
                MaterialId.PlexiglassWhite,
                MaterialId.PolycarbonateOpaque,
                MaterialId.PolycarbonateTeinted,
                MaterialId.PolycarbonateTransparent,
                MaterialId.Pvc,
                MaterialId.PvcRigid,
                MaterialId.DektonDanae,
                MaterialId.DektonEther,
                MaterialId.DektonHelena,
                MaterialId.DektonKhalo,
                MaterialId.DektonKira,
                MaterialId.DektonKylia,
                MaterialId.DektonLaurent,
                MaterialId.DektonLiquidEmbers,
                MaterialId.DektonLiquidSky,
                MaterialId.DektonRem,
                MaterialId.DektonSoke,
                MaterialId.DektonStrato,
                MaterialId.DektonVienna,
                MaterialId.DektonWhiteConcrete,
                MaterialId.CorianAnthracite,
                MaterialId.CorianBurledBeach,
                MaterialId.CorianBurled,
                MaterialId.CorianCocoaPrima,
                MaterialId.CorianCosmosPrima,
                MaterialId.CorianDeepBlackQuartz,
                MaterialId.CorianDusk,
                MaterialId.CorianEveningPrima,
                MaterialId.CorianGlacierWhite,
                MaterialId.CorianGrayOnyx,
                MaterialId.CorianHazelnut,
                MaterialId.CorianLimestonePrima,
                MaterialId.CorianLinen,
                MaterialId.CorianNimbusPrima,
                MaterialId.CorianStratus,
                MaterialId.CorianTumbleweed,
                MaterialId.CorianWhiteOnyx,
                MaterialId.CorianXitchHazel,
            ]),
        required: false,
    },
};

export const fieldsLowTableBorders: IFormFieldShape = {
    value    : undefined,
    options  : allBorders,
    required : true,
};

export const fieldsLowTableLegs: IFormFieldShape = {
    value   : undefined,
    options : getLegsWithExceptions(allLegs,
        [
            LegsShapeId.LegsMikado,
            LegsShapeId.LegsMonastery,
            LegsShapeId.LegsTrestleCross,
            LegsShapeId.LegsTrapezeCentral,
            LegsShapeId.LegsVShaped,
            LegsShapeId.LegsVShapedCentral,
            LegsShapeId.LegsUShapedStrengthened,
        ]),
    required: true,
};

export const fieldsLowTableLegsMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allMetals,
                ...allSolidWoods,
                ...allConcretes,
                ...allCeramics,
                ...allMarbleAndStones,
            ],
            [
                MaterialId.BlackLocust,
                MaterialId.Iroko,
                MaterialId.Douglas,
                MaterialId.Redcedar,
                MaterialId.Larch,
                MaterialId.Padouk,
                MaterialId.Ipe,
                MaterialId.Brass,
                MaterialId.Zinc,
            ],
        ),
        required: true,
    },
};

export const fieldsLowTableOptions: IFormFieldShapeQuantities = {
    [LowTableId.LowTableDoubleTray]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
    [LowTableId.LowTableDrawer]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
    [LowTableId.LowTableLed]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
    [LowTableId.LowTableLiftableTray]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
    [LowTableId.LowTableOpenStorage]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
    [LowTableId.LowTableSlidingStorage]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
    [LowTableId.LowTableDocumentHolder]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
};

